export const container: CSSFunction = () => ({
  width: '100%',
  justifyContent: 'flex-end',
  alignItems: 'center',
});
